const GET_ASSET_READINESS_WORK_BOOK_GRID = 'GET_ASSET_READINESS_WORK_BOOK_GRID';
const SET_ASSET_READINESS_WORK_BOOK_GRID = 'SET_ASSET_READINESS_WORK_BOOK_GRID';

const GET_SAVE_ASSET_READINESS_WORK_BOOK = 'GET_SAVE_ASSET_READINESS_WORK_BOOK';
const SET_SAVE_ASSET_READINESS_WORK_BOOK = 'SET_SAVE_ASSET_READINESS_WORK_BOOK';

const GET_AUDIT_DATE_LIST = "GET_AUDIT_DATE_LIST";
const SET_AUDIT_DATE_LIST = "SET_AUDIT_DATE_LIST";

const GET_AUDIT_READINESS_DATE_LIST = "GET_AUDIT_READINESS_DATE_LIST";
const SET_AUDIT_READINESS_DATE_LIST = "SET_AUDIT_READINESS_DATE_LIST";

const GET_AUDIT_TRAINING_DATE_LIST = "GET_AUDIT_TRAINING_DATE_LIST";
const SET_AUDIT_TRAINING_DATE_LIST = "SET_AUDIT_TRAINING_DATE_LIST";

const IS_DROP_DOWNS_LOADING = 'IS_DROP_DOWNS_LOADING'

const SET_IS_WORKBOOK_GRID_BIND_ONLOAD = 'SET_IS_WORKBOOK_GRID_BIND_ONLOAD';

const SET_ASSET_READINESS_WORK_BOOK_FILTER = 'SET_ASSET_READINESS_WORK_BOOK_FILTER';

const GET_CURRENT_AUDIT_CYCLE = "GET_CURRENT_AUDIT_CYCLE";
const SET_CURRENT_AUDIT_CYCLE = "SET_CURRENT_AUDIT_CYCLE";

export {
    GET_ASSET_READINESS_WORK_BOOK_GRID,
    SET_ASSET_READINESS_WORK_BOOK_GRID,
    GET_SAVE_ASSET_READINESS_WORK_BOOK,
    SET_SAVE_ASSET_READINESS_WORK_BOOK,
    GET_AUDIT_DATE_LIST,
    SET_AUDIT_DATE_LIST,
    GET_AUDIT_READINESS_DATE_LIST,
    SET_AUDIT_READINESS_DATE_LIST,
    GET_AUDIT_TRAINING_DATE_LIST,
    SET_AUDIT_TRAINING_DATE_LIST,
    IS_DROP_DOWNS_LOADING,
    SET_IS_WORKBOOK_GRID_BIND_ONLOAD,
    SET_ASSET_READINESS_WORK_BOOK_FILTER,
    GET_CURRENT_AUDIT_CYCLE,
    SET_CURRENT_AUDIT_CYCLE
};
